// mapping of error code to error property
export const campaignApiErrorCodeToPropertyMapping = {
  // Campaigns
  CampaignServiceCannotCreateDuplicateCampaign: 'Name',
  CampaignServiceInvalidCampaignName: 'Name',
  AssetGroupAlreadyExists: 'Name',
  CampaignServiceInvalidDailyBudget: 'Budget',
  InvalidTargetRoasValue: 'BiddingScheme',
  ConversionGoalCriteriaNotMetForBiddingScheme: 'BiddingScheme',
  CampaignServiceInvalidLanguage: 'Languages',

  // AdGroups
  CampaignServiceCannotCreateDuplicateAdGroup: 'Name',

  // Others
  CampaignInvalidDynamicSearchAdsDomainName: 'DomainName',

  // Expanded Text Ad
  ExpandedTextAdPath2SetWithoutPath1: 'Path1',
  ExpandedTextAdCombinedTitleTooLong: 'TitlePart2', // the combined title exceeding 80 characters
  ExpandedTextAdFinalUrlDomainTooLong: 'FinalUrls', // the domain from the final Url exceeding 35 characters
  ExpandedTextAdDisplayUrlDomainTooLong: 'DisplayUrl',
  ExpandedTextAdDisplayUrlDomainInvalid: 'DisplayUrl',

  CampaignServiceExpandedTextAdCombinedTitleTooLong: 'TitlePart2', // the combined title exceeding 80 characters
  CampaignServiceExpandedTextAdFinalUrlDomainTooLong: 'FinalUrls', // the domain from the final Url exceeding 35 characters
  CampaignServiceExpandedTextAdPath2SetWithoutPath1: 'Path1',
  CampaignServiceExpandedTextAdTitlePart1TooLong: 'TitlePart1',
  CampaignServiceExpandedTextAdTitlePart2TooLong: 'TitlePart2',
  CampaignServiceExpandedTextAdTitlePart1Invalid: 'TitlePart1',
  CampaignServiceExpandedTextAdTitlePart2Invalid: 'TitlePart2',
  CampaignServiceExpandedTextAdPath1TooLong: 'Path1',
  CampaignServiceExpandedTextAdPath2TooLong: 'Path2',
  CampaignServiceExpandedTextAdPath1Invalid: 'Path1',
  CampaignServiceExpandedTextAdPath2Invalid: 'Path2',
  CampaignServiceExpandedTextAdDisplayUrlDomainTooLong: 'DisplayUrl',
  CampaignServiceExpandedTextAdDisplayUrlDomainInvalid: 'DisplayUrl',

  // Text Ad
  CampaignServiceInvalidAdTitle: 'Title',
  CampaignServiceEditorialAdTitleBlank: 'Title',
  CampaignServiceEditorialAdTitleBlankAcrossAllAssociations: 'Title',
  CampaignServiceSyntaxErrorInAdTitle: 'Title',
  CampaignServiceEditorialErrorInAdTitle: 'Title',
  CampaignServicePhoneNumberNotAllowedInAdTitle: 'Title',
  CampaignServiceTooMuchAdTextInTitle: 'Title',
  CampaignServiceTooMuchTextInTitleAcrossAllAssociations: 'Title',
  CampaignServiceIncorrectAdFormatInTitle: 'Title',
  CampaignServiceForbiddenTextInAdTitle: 'Title',
  CampaignServiceExclusiveWordInAdTitle: 'Title',
  CampaignServiceDefaultAdExclusiveWordInTitle: 'Title',
  CampaignServiceDefaultAdForbiddenWordInTitle: 'Title',
  CampaignServiceDefaultAdSyntaxErrorInTitle: 'Title',
  CampaignServiceDefaultAdTooMuchTextInTitle: 'Title',
  CampaignServiceDefaultAdIncorrectAdFormatInTitle: 'Title',

  CampaignServiceInvalidAdText: 'Text',
  CampaignServiceEditorialAdTextBlank: 'Text',
  CampaignServiceEditorialAdTextBlankAcrossAllAssociations: 'Text',
  CampaignServiceSyntaxErrorInAdText: 'Text',
  CampaignServiceEditorialErrorInAdText: 'Text',
  CampaignServicePhoneNumberNotAllowedInAdText: 'Text',
  CampaignServiceTooMuchAdTextInText: 'Text',
  CampaignServiceTooMuchTextInTextAcrossAllAssociations: 'Text',
  CampaignServiceIncorrectAdFormatInText: 'Text',
  CampaignServiceForbiddenTextInAdText: 'Text',
  CampaignServiceExclusiveWordInAdText: 'Text',
  CampaignServiceNotEnoughAdText: 'Text',
  CampaignServiceCampaignServiceDefaultAdExclusiveWordInText: 'Text',
  CampaignServiceDefaultAdForbiddenWordInText: 'Text',
  CampaignServiceDefaultAdSyntaxErrorInText: 'Text',
  CampaignServiceDefaultAdTooMuchTextInText: 'Text',
  CampaignServiceDefaultAdIncorrectAdFormatInText: 'Text',

  CampaignServiceInvalidAdDisplayUrl: 'DisplayUrl',
  CampaignServiceEditorialAdDisplayUrlBlank: 'DisplayUrl',
  CampaignServiceEditorialAdDisplayUrlBlankAcrossAllAssociations: 'DisplayUrl',
  CampaignServiceSyntaxErrorInAdDisplayUrl: 'DisplayUrl',
  CampaignServiceEditorialErrorInAdDisplayUrl: 'DisplayUrl',
  CampaignServicePhoneNumberNotAllowedInAdDisplayUrl: 'DisplayUrl',
  CampaignServiceTooMuchAdTextInDisplayUrl: 'DisplayUrl',
  CampaignServiceTooMuchTextInDisplayUrlAcrossAllAssociations: 'DisplayUrl',
  CampaignServiceIncorrectAdFormatInDisplayUrl: 'DisplayUrl',
  CampaignServiceForbiddenTextInAdDisplayUrl: 'DisplayUrl',
  CampaignServiceExclusiveWordInAdDisplayUrl: 'DisplayUrl',
  CampaignServiceInvalidAdDisplayUrlFormat: 'DisplayUrl',
  CampaignServiceDefaultAdExclusiveWordInDisplayUrl: 'DisplayUrl',
  CampaignServiceDefaultAdForbiddenWordInDisplayUrl: 'DisplayUrl',
  CampaignServiceDefaultAdSyntaxErrorInDisplayUrl: 'DisplayUrl',
  CampaignServiceDefaultAdTooMuchTextInDisplayUrl: 'DisplayUrl',
  CampaignServiceDefaultAdIncorrectAdFormatInDisplayUrl: 'DisplayUrl',
  CampaignServiceDefaultAdInvalidDisplayUrlFormat: 'DisplayUrl',

  CampaignServiceInvalidAdDestinationUrl: 'DestinationUrl',
  CampaignServiceEditorialAdDestinationUrlBlank: 'DestinationUrl',
  CampaignServiceEditorialErrorInAdDestinationUrl: 'DestinationUrl',
  CampaignServiceTooMuchAdTextInDestinationUrl: 'DestinationUrl',
  CampaignServiceInvalidAdDestinationUrlFormat: 'DestinationUrl',
  CampaignServiceDefaultAdTooMuchTextInDestinationUrl: 'DestinationUrl',
  CampaignServiceDefaultAdInvalidDestinationUrlFormat: 'DestinationUrl',

  // App Install Ad
  CampaignServiceAppInstallAdAppPlatformInvalid: 'AppPlatform',
  CampaignServiceAppInstallAdAppPlatformNullOrEmpty: 'AppPlatform',
  CampaignServiceAppInstallAdAppStoreIdInvalid: 'AppStoreId',
  CampaignServiceAppInstallAdAppStoreIdTooMuchText: 'AppStoreId',
  CampaignServiceAppInstallAdAppStoreIdIsNullOrEmpty: 'AppStoreId',
  CampaignServiceAppInstallAdUpdateAppPlatformChanged: 'AppPlatform',
  CampaignServiceAppInstallAdUpdateAppStoreIdChanged: 'AppStoreId',

  // shared budget
  CampaignServiceDuplicateBudgetName: 'Name',
  CampaignServiceBudgetNameMissing: 'Name',
  CampaignServiceBudgetNameTooLong: 'Name',
  CampaignServiceBudgetNameInvalid: 'Name',
  CampaignServiceBudgetAmountMissing: 'Amount',
  CampaignServiceBudgetAmountIsAboveLimit: 'Amount',
  CampaignServiceBudgetAmountIsBelowLimit: 'Amount',

  // Verified Impression Tracking
  VerifiedTrackingDataInvalid: 'CampaignSettings',

  // Impression tracking Urls
  ImpressionTrackingUrlInvalid: 'ImpressionTrackingUrls',

  InvalidFeedIdsForAssociation: 'FeedAssociations',

};
